"use strict";
exports.__esModule = true;
var url_1 = require("./url");
var validatePattern = function (value) {
    if (!value) {
        return '';
    }
    value = value.replace('*', 'a');
    return url_1["default"](value, false);
};
exports["default"] = validatePattern;
